export const setTestGroup = ( name, group ) => ( {
    type: 'SET_TEST_GROUP',
    name: name,
    group: group,
} );
